import { FC } from 'react';
import styles from './RemoveCoupon.module.css';
import config from 'config-base';
import clsx from 'clsx';
import { RemoveCouponButtonProps } from './types';

const RemoveCouponButton: FC<RemoveCouponButtonProps> = ({ id, onClick }) => (
  <div
    id={`${id}-remove-btn`}
    data-testid={`${id}-remove-btn`}
    className={clsx(styles.endAdornment, { [styles.removePromoAGD]: config.brandCode !== '0' })}
    onClick={onClick}
  >
    <span className={clsx({ [styles.endAdornmentAGD]: config.brandCode !== '0' })}>Remove</span>
    <span className={clsx(styles.removeCouponIcon, { [styles.removeCouponIconAGD]: config.brandCode !== '0' })}>
      &nbsp;X
    </span>
  </div>
);
//&#x2715;
export default RemoveCouponButton;
